"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ModalDetailCard", {
  enumerable: true,
  get: function get() {
    return _ModalDetailCard.default;
  }
});
var _ModalDetailCard = _interopRequireDefault(require("./ModalDetailCard"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }